import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';
import { LandingPage } from './pages/LandingPage';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { HallOfRagePage } from './pages/HallOfRagePage';
import { NicknamePromptModal } from './components/NicknamePromptModal';
import { UpdateNotification } from './components/UpdateNotification';
import { getCurrentUser, getDisplayName } from './authService';
import { supabase } from './config/supabaseClient';
import { register, skipWaiting } from './utils/serviceWorkerRegistration';
const APP_VERSION = '1.0.10'; // Increment to force service worker update
export function App() {
  const [showNicknamePrompt, setShowNicknamePrompt] = useState(false);
  const [isCheckingUser, setIsCheckingUser] = useState(true);
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  useEffect(() => {
    console.log(`🚀 IBD Rant v${APP_VERSION} loaded`);
    console.log('📅 Build timestamp:', new Date().toISOString());
    try {
      register(() => {
        console.log('🔄 New version detected!');
        setShowUpdateNotification(true);
      });
    } catch (error) {
      console.log('ℹ️ Service worker not available');
    }
    const checkUserDisplayName = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          const displayName = await getDisplayName(user.id);
          if (!displayName) {
            setShowNicknamePrompt(true);
          }
        }
      } catch (error) {
        console.error('Error checking user display name:', error);
      } finally {
        setIsCheckingUser(false);
      }
    };
    checkUserDisplayName();
    const {
      data: authListener
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        const displayName = await getDisplayName(session.user.id);
        if (!displayName) {
          setShowNicknamePrompt(true);
        }
      }
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);
  const handleUpdate = () => {
    skipWaiting();
    window.location.reload();
  };
  return <HelmetProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/confirmation" element={<ConfirmationPage data-id="element-6" />} data-id="element-5" />
          <Route path="/hall-of-rage" element={<HallOfRagePage data-id="element-8" />} data-id="element-7" />
        </Routes>
        <AnimatePresence data-id="element-9">
          {showNicknamePrompt && !isCheckingUser && <NicknamePromptModal onComplete={() => setShowNicknamePrompt(false)} data-id="element-10" />}
          {showUpdateNotification && <UpdateNotification onUpdate={handleUpdate} onDismiss={() => setShowUpdateNotification(false)} data-id="element-11" />}
        </AnimatePresence>
      </BrowserRouter>
    </HelmetProvider>;
}
export { APP_VERSION };